import React, { Component } from "react";
import {
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  form,
  Panel,
  Checkbox,
  Table,
  Col,
  Row,
} from "react-bootstrap";
import {
  getParams,
  end_point,
  getMonth,
  total0Recept,
  mmddyyyyDateFormat,
  filterSearch,
  makeUniqueKey,
  instalment_field,
  applyOrganizationTheme,
  formatSessionDateLabel,
  sortProgramSessions,
} from "./helper";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import AccountInfo from "./EnrollmentFormComponents/accountInfo";
import AthleteInfo from "./EnrollmentFormComponents/athleteInfo";
import WaitlistTransactionFields from "./EnrollmentFormComponents/waitlistMerchfields";
import NoWaitlistTransFields from "./EnrollmentFormComponents/nowaitlistMerchfields";
import ProgramDetails from "./EnrollmentFormComponents/programDetails";
import PriceBreakdown from "./EnrollmentFormComponents/priceBreakdown";
import { Elements, StripeProvider, injectStripe } from "react-stripe-elements";
import HamburgerNavbar from "./hamburgerNavbar";
import OrganizationBar from "./organizationBar";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import StripePaymentGateway from "./enrollmentFormFunctions/StripePaymentGateway";
import ConvergePaymentGateway from "./enrollmentFormFunctions/ConvergePaymentGateway";
import LeagueEnrolment from './leagueEnrolment';
import moment from 'moment';

const $ = require("jquery");
const playerEvents = [
  "camp",
  "academy",
  "class",
  "club team",
  "house league",
  "open gym",
  "showcase",
  "virtual training",
  "skill session",
  "tryout",
  "private training",
];
const teamEvents = [
  "tournament",
  "rep league",
  "team camp",
  "private training (team)",
  "virtual training (team)",
];

//PROGRAMS LISTS
class EnrollmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // checkout: false, // TODO: Pull in for each organization.
      dataReserve: [],
      gateway: "converge",
      stripe_account: "",
      currencyType: "CAD",
      all_programs: [],
      athlete_birth_date: null,
      athletes: [],
      convergeToken: null,
      createAthlete: false,
      endpoint: `${end_point()}/enrollment`,
      loginEndpoint: `${end_point("users")}/login`,
      stripeEndPoint: `${end_point("stripe")}/charge`,
      stripeKey: `${end_point("stripe_pub_key")}`,
      organization_id:
        getParams().organization_id || localStorage.getItem("organization_id"),
      organization_name: getParams().organization_name
        ? decodeURIComponent(getParams().organization_name)
        : localStorage.getItem("organization_name"),
      parent_email: props.email || localStorage.getItem("parent_email"),
      parent: null,
      paymentStatus: null,
      pricingEndpoint: `${end_point()}/pricing`,
      pricingBreakdown: {},
      programUDFs: null,
      programs: [],
      playerEventPrograms: [],
      teamEventPrograms: [],
      filteredPrograms: [],
      transactionEndpoint: `${end_point("transactions")}/transactions`,
      selected_program: null,
      eventFilterType: 0,
      showForm: false,
      selected_athlete: null,
      search: getParams().search || props.search,
      selected_plan: null,
      select_class: "orange_background",
      showPricingBreakdown: false,
      validationMessage: "",
      showWaiverModal: false,
      token: getParams().jwt || props.token,
      tokenGenerator: end_point("payments"),
      transaction_id: null,
      displayPaymentForm: false,
      organization_merch: [],
      continue_spinner: false,
      continue_0_spinner: false,
      confirm_spinner: false,
      pay_spinner: false,
      disabled: false,
      checkBoxDisabled: false,
      invalidFieldIds: [],
      waitlistInitialSignup: false,
      waitlistTransaction: null,
      waitlistMerch: {},
      instalments: [],
      instalment_number: 1,
      clubteamUser: false,
      loading: true,
      udfs: [],
      master_grid_readonly: false,
      pageSectionsRightPadding: "15px",
      previewFullForm:
        getParams().previewFullForm === "true" ||
        getParams().showFullForm === "true",
      previewProgramId: getParams().preview_program_id || getParams().program_id || null,
      testProgramMode: getParams().test_program === "true" || props.testProgram === true,
      testFormPrefilled: false,
    };
  }

  componentDidMount() {
    console.log("this.state.endpoint", this.state.endpoint);
    $.ajax({
      headers: {
        token: this.state.token,
        organization_id: this.state.organization_id,
      },
      method: "GET",
      dataType: "json",
      url: this.state.endpoint,
    }).then((data) => {
      const enrollmentMessage = data && data.message ? data.message : {};
      const organization = Array.isArray(enrollmentMessage.organization)
        ? enrollmentMessage.organization
        : [];
      const programsFromResponse = Array.isArray(enrollmentMessage.programs)
        ? enrollmentMessage.programs
        : [];
      const primaryOrganization = organization[0] || {
        payment_credentials: { gateway: "converge", currency_type: "CAD" },
        merch: [],
        udfs: [],
      };

      this.setState({
        loading: false,
        udfs: Array.isArray(primaryOrganization.udfs) ? primaryOrganization.udfs : [],
      });
      console.log("GET", enrollmentMessage);
      var programs = [];

      programsFromResponse.forEach((program) => {
        var type = program.type.toLowerCase();
        if (!(type === "rep League" || type === "tournament") || true) {
          programs.push(program);
        }
        return programs;
      });

      enrollmentMessage.programs = programs;
      console.log("programs?", enrollmentMessage.programs);

      this.haveEnrolmentData(enrollmentMessage);
    }).catch(() => {
      if (this.state.testProgramMode) {
        this.setState({ loading: false });
        this.haveEnrolmentData({
          organization: [
            {
              payment_credentials: { gateway: "converge", currency_type: "CAD" },
              merch: [
                {
                  name: "Test Tee",
                  logo: "tshirt.svg",
                  size: ["Youth S", "Youth M", "Youth L", "Adult S", "Adult M", "Adult L"],
                },
              ],
              udfs: [],
            },
          ],
          programs: [this.buildTestProgram()],
          athletes: [],
          parent: null,
        });
      }
    });
    if (window.matchMedia("(max-width: 750px)").matches) {
      console.log("scroll to top");
      window.scrollTo(0, 0);
    }
    const programsGridList = document.querySelector("#programslist");
    if (programsGridList) {
      const handleSelection = (event) => {
        const detail = event && event.detail ? event.detail : null;
        const selectedId =
          (detail && typeof detail === "object" && (detail._id || detail.id || detail.program_id || detail.programId)) ||
          (typeof detail === "string" ? detail : null) ||
          (event && event.target && event.target.value ? event.target.value : null) ||
          (event && event.target && event.target.dataset && (event.target.dataset.programId || event.target.dataset.id)) ||
          (event && event.currentTarget && event.currentTarget.value ? event.currentTarget.value : null);

        if (selectedId) {
          this.programSelectedhandler(selectedId);
          return;
        }

        if (detail && typeof detail === "object") {
          const selectedProgram =
            detail.program ||
            detail.selectedProgram ||
            detail.selected_item ||
            detail.selectedItem ||
            detail;
          if (selectedProgram && selectedProgram._id) {
            this.programSelectedhandler(selectedProgram);
          }
        }
      };

      ["selected", "change", "input", "program-selected"].forEach((eventName) => {
        programsGridList.addEventListener(eventName, handleSelection);
      });
    }
  }

  onLeagueEnrolmentTxnUnverified() {
    this.setState({master_grid_readonly: true});
  }

  addStatus = (data) => {
    if (!Array.isArray(data)) {
      return [];
    }
    data.forEach((program) => {
      program.status =
        program.status !== "waitlist" ? this.getStatus(program) : "waitlist";
    });
    return data;
  };

  getStatus = (data) => {
    var year = new Date().getFullYear();
    var date = ("0" + new Date().getDate()).slice(-2);
    var month = ("0" + (new Date().getMonth() + 1)).slice(-2);
    var today = `${year}-${month}-${date}T00:00:00.000Z`;
    if (
      data.registration_start_date === "1970-01-01T00:00:00.000Z" &&
      data.registration_end_date === "1970-01-01T00:00:00.000Z"
    ) {
      return "Cloned";
    }
    if (today >= data.start_date) {
      if (today > data.end_date) {
        return "Expired";
      }
      return "Live";
    } else if (today >= data.registration_start_date) {
      if (today > data.registration_end_date) {
        return "Closed";
      }
      return "Open";
    }
    return "Draft";
  };

  haveEnrolmentData = (enrollmentData) => {
    console.log("HAVE ENROLLMENT DATA HERE", enrollmentData);
    const organization = Array.isArray(enrollmentData.organization)
      ? enrollmentData.organization
      : [];
    const primaryOrganization = organization[0] || {
      payment_credentials: { gateway: "converge", currency_type: "CAD" },
      merch: [],
    };
    console.log(
      "checkout type?",
      primaryOrganization.payment_credentials.gateway
    );
    applyOrganizationTheme({
      navbar_color: primaryOrganization.navbar_color || '#5563b8',
      navbar_text_color: primaryOrganization.navbar_text_color || '#ffffff',
    })
    enrollmentData.programs = this.addStatus(Array.isArray(enrollmentData.programs) ? enrollmentData.programs : []);
    this.setState({
      gateway:
        primaryOrganization.payment_credentials.gateway === "stripe"
          ? "stripe"
          : "converge",
      stripe_account:
        primaryOrganization.payment_credentials.gateway === "stripe"
          ? primaryOrganization.payment_credentials.account
          : "",
      currencyType:
        primaryOrganization.payment_credentials.currency_type,
      all_programs: enrollmentData.programs,
      athletes: Array.isArray(enrollmentData.athletes) ? enrollmentData.athletes : [],
      organization_merch: Array.isArray(primaryOrganization.merch) ? primaryOrganization.merch : [],
    });
    if (this.state.token) {
      this.setState({ parent: enrollmentData.parent });
    }
    if (this.state.testProgramMode) {
      this.showPreviewProgram([this.buildTestProgram()]);
      return;
    }
    if (this.state.previewFullForm) {
      this.showPreviewProgram(enrollmentData.programs);
      return;
    }
    if (this.state.search) {
      console.log("search exists");
      this.filterList();
    } else if (getParams().transaction_id) {
      var transaction_id = getParams().transaction_id;
      console.log("At ID, to existed?", transaction_id);
      this.transactionExisted(transaction_id);
    } else if (getParams().clubteamUser) {
      this.setState({ clubteamUser: true });
      this.clubteamExisted(enrollmentData);
    } else {
      console.log("getting open programs");
      this.getOpenPrograms();
    }
    this.prepareEventFilterData();
  };

  getOpenProgramList = (programs) => {
    var temp_programs = [];
    var year = new Date().getFullYear();
    var date = ("0" + new Date().getDate()).slice(-2);
    var month = ("0" + (new Date().getMonth() + 1)).slice(-2);
    var today = `${year}-${month}-${date}T00:00:00.000Z`;
    programs.forEach((program) => {
      if (today >= program.registration_start_date) {
        if (today <= program.registration_end_date) {
          temp_programs.push(program);
        }
      }
    });
    return temp_programs;
  };

  filterList = () => {
    var temp_programs = this.getOpenProgramList(this.state.all_programs);
    console.log("temp_programs?", temp_programs);
    const programs = filterSearch(temp_programs, this.state.search);
    this.setState({
      programs: programs,
    });
    if(programs?.length > 0) {
      this.setState({
        filteredPrograms: programs.map(p => p._id)
      });
    } else {
      this.setState({
        filteredPrograms: ["-1"]
      });
    }
  };

  clubteamExisted = (data) => {
    var athleteFound = 0;
    var athletes = [];
    (Array.isArray(data.athletes) ? data.athletes : []).forEach((athlete) => {
      if (athlete._id === getParams().athlete_id) {
        athleteFound = 1;
        athletes.push(athlete);
      }
    });

    if (athleteFound === 0) {
      alert(
        "This invitation was not sent to you. Please sign in with the email that received the invitation to complete your enrolment."
      );
      window.location.href =
        document.location.origin + "/logout?jwt=" + this.state.token;
    } else {
      var programs = [];
      (Array.isArray(data.programs) ? data.programs : []).forEach((program) => {
        if (program._id === getParams().program_id) {
          programs.push(program);
        }
      });
      if (!programs[0]) {
        alert("This program could not be loaded. Please contact support.");
        window.location.href =
          document.location.origin + "/logout?jwt=" + this.state.token;
        return;
      }
      programs[0].plans.forEach((plan, i) => {
        if (plan._id === getParams().plan_id) {
          programs[0].plans = [plan];
        }
      });
      var instalments = [];
      if (
        programs[0].plans[0].instalments &&
        programs[0].plans[0].instalments.length !== 0
      ) {
        instalments = programs[0].plans[0].instalments;
      }
      this.setState(
        {
          programs,
          selected_program: programs[0],
          selected_plan: getParams().plan_id,
          athletes,
          selected_athlete: athletes[0],
          instalments,
        },
        () => console.log("Verify", this.state.selected_program)
      );
    }
  };

  transactionExisted = (transaction_id) => {
    const { token, organization_id } = this.state;
    const rthis = this;
    console.log(
      "headers: \norgId:",
      organization_id,
      "\ntrnx id:",
      transaction_id,
      "\ntoken:",
      token
    );
    $.ajax({
      headers: {
        token: token,
        organization_id: organization_id,
        transaction_id: transaction_id,
      },
      method: "GET",
      contentType: "application/json",
      url: this.state.transactionEndpoint,
      success: function (data) {
        if (data.errorMessage) {
          alert(data.errorMessage);
        } else {
          console.log("transactionExisted data", data);
          if (
            rthis.state.parent.first_name === data[0].parent.first_name &&
            rthis.state.parent.last_name === data[0].parent.last_name
          ) {
            data.length !== 1
              ? alert(
                  "We are unable find your transaction, please email support@hoopstir.com."
                )
              : rthis.transactionFound(data);
          } else {
            alert(
              "This invitation was not sent to you. Please sign in with the email that received the invitation to complete your enrolment."
            );
            window.location.href =
              document.location.origin + "/logout?jwt=" + rthis.state.token;
          }
        }
      },
      error: function (error) {
        alert(
          "We are unable to connect our server, please email support@hoopstir.com \nError Message",
          error
        );
      },
    });
  };

  transactionFound = (data) => {
    const transaction = data[0];
    // if the parent has paid already, then just display normal enrolment form
    if (
      (transaction.payment_gateway.type.type === "gratis" &&
        transaction.payment_gateway.status[
          transaction.payment_gateway.status.length - 1
        ].status === "unpaid") ||
      transaction.payment_gateway.status[
        transaction.payment_gateway.status.length - 1
      ].status === "paid"
    ) {
      alert("This invitation has already been accepted.");
      window.location.href =
        document.location.origin +
        "/portals?jwt=" +
        this.state.token +
        "&protalMode=parent";
    } else {
      const { all_programs, athletes } = this.state;
      var program = all_programs.filter(
        (program) => program._id === transaction.program._id
      );
      let instalments = [];
      var selected_program = program[0];
      //look if instalment options exist
      selected_program.plans.forEach((plan) => {
        if (plan._id === transaction.plan._id) {
          instalments = plan.instalments ? plan.instalments : [];
          selected_program.plans = [plan];
        }
      });
      this.setState(
        {
          programs: program,
          selected_program: program[0],
          selected_plan: transaction.plan._id,
          athletes: athletes.filter(
            (athlete) => athlete._id === transaction.athlete._id
          ),
          waitlistTransaction: transaction,
          waitlistMerch: transaction.merch,
          transaction_id: transaction._id,
          instalments: instalments,
          instalment_number: transaction.price_breakdown.instalment_number
            ? transaction.price_breakdown.instalment_number
            : 1,
        },
        () => console.log("Verify", this.state.selected_program)
      );
    }
  };

  getOpenPrograms = () => {
    var temp_programs = this.getOpenProgramList(this.state.all_programs);
    this.setState({
      programs: temp_programs,
      filteredPrograms: temp_programs.length > 0 ? temp_programs.map((program) => program._id) : ["-1"],
    });
  };

  getInputValue = (id) => {
    const element = document.getElementById(id);
    return element ? element.value : "";
  }

  isInputChecked = (id) => {
    const element = document.getElementById(id);
    return !!(element && element.checked);
  }

  showPreviewProgram = (programs) => {
    const openPrograms = this.getOpenProgramList(programs || this.state.all_programs);
    const testProgram = this.state.testProgramMode ? this.buildTestProgram() : null;
    const targetProgram =
      testProgram ||
      openPrograms.find((program) => program._id === this.state.previewProgramId) ||
      openPrograms[0];

    if (!targetProgram) {
      this.setState({ programs: openPrograms });
      return;
    }

    let selectedPlan = null;
    let instalments = [];
    if (targetProgram.plans && targetProgram.plans.length === 1) {
      selectedPlan = targetProgram.plans[0]._id;
      if (targetProgram.plans[0].instalments && targetProgram.plans[0].instalments.length !== 0) {
        instalments = targetProgram.plans[0].instalments;
      }
    }
    const previewPlanPrice =
      targetProgram.plans && targetProgram.plans.length > 0
        ? targetProgram.plans[0].plan_price
        : 0;

    const forceFullPreview = this.state.previewFullForm

    this.setState(
      {
        programs: openPrograms,
        filteredPrograms: [targetProgram._id],
        selected_program: targetProgram,
        selected_plan: selectedPlan,
        instalments,
        showForm: true,
        continue_0_spinner: false,
        continue_spinner: false,
        displayPaymentForm: forceFullPreview,
        showPricingBreakdown: forceFullPreview,
        waitlistInitialSignup: false,
        selected_athlete: null,
        createAthlete: false,
        paymentStatus: null,
        pricingBreakdown: forceFullPreview
          ? {
              membership_fee: 0,
              processing_fee: 0,
              total: previewPlanPrice,
              plan_price: previewPlanPrice,
              instalment_number:
                targetProgram.plans && targetProgram.plans.length > 0
                  ? targetProgram.plans[0].instalments &&
                    targetProgram.plans[0].instalments.length > 0
                    ? targetProgram.plans[0].instalments.length
                    : 1
                  : 1,
              instalment_total: previewPlanPrice,
              extra_fees: [],
              early_bird_applied: false,
          }
          : this.state.pricingBreakdown,
      },
      () => this.prepareEventFilterData()
    );
  };

  buildTestProgram = () => {
    const startDate = moment().add(14, "days").startOf("day");
    const endDate = startDate.clone().add(6, "weeks").endOf("day");
    const registrationStartDate = moment().startOf("day");
    const registrationEndDate = startDate.clone().subtract(1, "day").endOf("day");

    return {
      _id: "test-program-preview",
      type: "camp",
      ages: "Ages 8-12",
      division: "co-ed",
      group_name: "The Test program",
      status: "Open",
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      registration_start_date: registrationStartDate.toISOString(),
      registration_end_date: registrationEndDate.toISOString(),
      program_description: "This is a preview-only enrollment form for UI testing.",
      additional_notes: "Use this view to check layout, spacing, and field behavior.",
      sessions: [
        {
          id: "test-session-1",
          type: "Practice",
          day: "Monday",
          date: startDate.format("YYYY-MM-DD"),
          start_time: "06:00 PM",
          end_time: "07:30 PM",
          location: "Test Venue",
        },
        {
          id: "test-session-2",
          type: "Practice",
          day: "Wednesday",
          date: startDate.clone().add(2, "days").format("YYYY-MM-DD"),
          start_time: "06:00 PM",
          end_time: "07:30 PM",
          location: "Test Venue",
        },
        {
          id: "test-session-3",
          type: "Practice",
          day: "Friday",
          date: startDate.clone().add(4, "days").format("YYYY-MM-DD"),
          start_time: "06:00 PM",
          end_time: "07:30 PM",
          location: "Test Venue",
        },
      ],
      plans: [
        {
          _id: "test-plan-1",
          plan_name: "Standard",
          plan_price: 125,
          instalments: [],
        },
      ],
      item_0_cost: 25,
      item_1_cost: null,
      item_2_cost: null,
      ageVerify: false,
      waiver: "OW Preview waiver text",
      udfs: [],
    };
  };

  handleWaiverModal = () => {
    this.setState({ showWaiverModal: !this.state.showWaiverModal });
  };

  handleWaiverChange = (checked) => {
    this.setState((prevState) => ({
      invalidFieldIds: checked
        ? prevState.invalidFieldIds.filter((id) => id !== "terms_checked")
        : prevState.invalidFieldIds,
      validationMessage:
        checked && prevState.validationMessage === "Please check the waiver box before continuing."
          ? ""
          : prevState.validationMessage,
    }));
  };

  resetPricingBreakdown = () => {
    const { waitlistTransaction } = this.state;
    if (waitlistTransaction) {
      var promo_code_key = this.getInputValue("promotion_code");
      waitlistTransaction.price_breakdown.promo_code_key = promo_code_key;
      waitlistTransaction.merch.item_0 =
        this.isInputChecked("item_0")
          ? this.getInputValue("item_0_size")
          : false;
      waitlistTransaction.merch.item_1 =
        this.isInputChecked("item_1")
          ? this.getInputValue("item_1_size")
          : false;
      waitlistTransaction.merch.item_2 =
        this.isInputChecked("item_2")
          ? this.getInputValue("item_2_size")
          : false;
      this.setState({ waitlistTransaction });
    }
    this.setState({
      displayPaymentForm: false,
      checkBoxDisabled: false,
    });
  };

  getSelectedPlanId = () => {
    if (!this.state.selected_program || !this.state.selected_program.plans) {
      return null;
    }
    if (this.state.selected_program.plans.length === 1) {
      return this.state.selected_program.plans[0]._id;
    }
    return this.state.selected_plan;
  };

  programSelectedhandler = (selection) => {
    // var val = selection.target ? selection.target.value : selection
    //console.log('program selected', selection)
    const selectedProgramId =
      selection && typeof selection === "object"
        ? selection._id || selection.id || selection.program_id || selection.programId
        : selection;
    if (selectedProgramId) {
      var selected_program =
        typeof selection === "object" && selection._id
          ? selection
          : this.state.programs.find((element) => {
              return element._id === selectedProgramId;
            });
      console.log("selected_program", selected_program);
      if(!selected_program) {
        return;
      }
      var waitlistInitialSignup =
        !this.state.transaction_id && selected_program.status === "waitlist"
          ? true
          : false;
      var instalment = [];
      if (
        selected_program.plans.length === 1 &&
        selected_program.plans[0].instalments &&
        selected_program.plans[0].instalments.length !== 0
      ) {
        instalment = selected_program.plans[0].instalments;
      }
      console.log("instalment", instalment);
      if (selected_program.league_organization_id) {
        console.log("this is an ext league - no merch");
      }

      if (selected_program.plans.length === 1) {
        this.setState({ selected_plan: selected_program.plans[0]._id, invalidFieldIds: [] });
      } else {
        this.setState({ selected_plan: null, invalidFieldIds: [] });
      }

      // UDFS
      if (selected_program.udfs && selected_program.udfs.length > 0) {
        console.log("program udfs", selected_program.udfs);
        console.log("org UDFS", this.state.udfs);
        var udfInfo = [];
        selected_program.udfs.forEach((udf) => {
          this.state.udfs.find((info) => {
            if (info.key === udf) {
              udfInfo.push(info);
            }
          });
        });
        console.log(udfInfo);
        this.setState({ programUDFs: udfInfo });
      } else {
        this.setState({ programUDFs: null });
      }

      this.setState({
        continue_0_spinner: false,
        selected_program: selected_program,
        checkBoxDisabled: false,
        instalments: instalment,
        showPricingBreakdown: false,
        displayPaymentForm: false,
        waitlistInitialSignup,
        instalment_number: 1,
        pageSectionsRightPadding: "30px",
      });
    }
  };

  athlete_mapping = {
    athlete_first_name: x => x.first_name,
    athlete_last_name: x => x.last_name,
    athlete_email: x => x.email,
    athlete_phone: x => x.extras.phone,
    athlete_gender: x => x.extras.gender,
    athlete_address: x => x.extras.address,
    athlete_postal_code: x => x.extras.postal_code,
    athlete_city: x => x.extras.city,
    athlete_province: x => x.extras.province,
    athlete_parent_notes: x => x.extras.parent_notes
  }

  updateFormData = (selected_athlete, reset) => {
    const elementIds = Object.keys(this.athlete_mapping);
    for(let id of elementIds) {
      if(reset || !selected_athlete) {
        document.getElementById(id).value = '';
      } else {
        document.getElementById(id).value = this.athlete_mapping[id](selected_athlete)
      }
    }
    if(reset || !selected_athlete) {
      this.setState({athlete_birth_date: null});
    } else {
      this.setState({athlete_birth_date: moment(selected_athlete.extras.date_of_birth)})
    }
  }

  checkFormElementsAndUpdate = (selected_athlete, reset = false) => {
    const elementIds = Object.keys(this.athlete_mapping);
    const elements = elementIds.map(id => document.getElementById(id));
    if(elements.every(e => e!== null)) {
      this.updateFormData(selected_athlete, reset);
    } else {
      setTimeout(() => this.checkFormElementsAndUpdate(selected_athlete, reset), 100);
    }
  }

  athleteSelectHandler = (selection) => {
    const { organization_id, programUDFs } = this.state;
    if (selection.target.value === "create_new_user") {
      this.setState({
        createAthlete: true,
        selected_athlete: null,
        validationMessage: "",
        invalidFieldIds: this.state.invalidFieldIds.filter(
          (id) => id !== "selected_athlete"
        ),
      });
      this.checkFormElementsAndUpdate(null, true);
    } else {
      var selected_athlete = this.state.athletes.find((athlete) => {
        return athlete._id === selection.target.value;
      });
      console.log(
        "Selected Athlete Info:",
        selected_athlete,
        "\norg id",
        organization_id,
        "\nprogramUDFs",
        programUDFs
      );
      var udfsInfo = [];
      var udfs = selected_athlete.udfs ? selected_athlete.udfs.slice() : null;

      if (udfs && programUDFs) {
        udfs.forEach((udf) => {
          if (udf.organization_id === organization_id) {
            programUDFs.find((programUDF) => {
              if (programUDF.key === udf.key) {
                udfsInfo.push(udf);
              }
            });
          }
        });
        selected_athlete.udfs = udfsInfo;
        console.log("udfsInfo", udfsInfo);
      }
      this.setState({
        createAthlete: false,
        selected_athlete: selected_athlete,
        validationMessage: "",
        invalidFieldIds: this.state.invalidFieldIds.filter(
          (id) => id !== "selected_athlete"
        ),
      });


      this.checkFormElementsAndUpdate(selected_athlete);
    }
  };

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.selected_program != this.state.selected_program && !this.state.previewFullForm) {
      this.setState({
        showForm: false,
      });
    }
    if (
      this.state.testProgramMode &&
      this.state.showForm &&
      !this.state.testFormPrefilled
    ) {
      this.fillTestFormData();
    }
  }

  showFormFields = () => {
    if (!this.getSelectedPlanId()) {
      this.setState({
        validationMessage: "Please select a price plan before continuing.",
        invalidFieldIds: ["selected_plan"],
        continue_0_spinner: false,
      });
      const selectedPlanField = document.getElementById("selected_plan");
      if (selectedPlanField && typeof selectedPlanField.scrollIntoView === "function") {
        selectedPlanField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (selectedPlanField && typeof selectedPlanField.focus === "function") {
        selectedPlanField.focus();
      }
      return;
    }

    this.setState({
      showForm: true,
      validationMessage: "",
      continue_0_spinner: false,
    });
  };

  fillTestFormData = () => {
    const values = {
      parent1_first_name: "Jamie",
      parent1_last_name: "Tester",
      parent1_phone: "6045550101",
      parent2_first_name: "Jordan",
      parent2_last_name: "Tester",
      parent2_email: "secondary@example.com",
      parent2_phone: "6045550102",
      athlete_first_name: "Avery",
      athlete_last_name: "Tester",
      athlete_gender: "female",
      athlete_email: "athlete@example.com",
      athlete_phone: "6045550103",
      athlete_address: "123 Test Street",
      athlete_city: "Vancouver",
      athlete_province: "BC",
      athlete_postal_code: "V6B 1A1",
      athlete_parent_notes: "Dummy data for test enrollment flow.",
    };

    Object.keys(values).forEach((id) => {
      const field = document.getElementById(id);
      if (field) {
        field.value = values[id];
      }
    });

    const birthDateField = moment().subtract(9, "years").toDate();
    this.setState({
      athlete_birth_date: moment(birthDateField),
      createAthlete: true,
      testFormPrefilled: true,
    });

    const terms = document.getElementById("terms_checked");
    if (terms) {
      terms.checked = true;
    }
  };

  refreshPricingBreakdown = () => {
    if (!this.state.selected_program) {
      return;
    }
    const selectedPlanId = this.getSelectedPlanId();
    if (!selectedPlanId) {
      return;
    }
    var data = {
      item_0: document.getElementById("item_0")
        ? document.getElementById("item_0").checked
        : false,
      item_1: document.getElementById("item_1")
        ? document.getElementById("item_1").checked
        : false,
      item_2: document.getElementById("item_2")
        ? document.getElementById("item_2").checked
        : false,
      promo_code_key: this.getInputValue("promotion_code"),
      program_id: this.state.selected_program._id,
      instalment_number: this.state.instalment_number,
      plan_id: selectedPlanId,
    };
    if (this.state.testProgramMode) {
      const selectedPlan =
        this.state.selected_program.plans.find((plan) => plan._id === selectedPlanId) ||
        this.state.selected_program.plans[0];
      const planPrice = Number(selectedPlan ? selectedPlan.plan_price : 0);
      const item0Selected = !!document.getElementById("item_0") && document.getElementById("item_0").checked;
      const item1Selected = !!document.getElementById("item_1") && document.getElementById("item_1").checked;
      const item2Selected = !!document.getElementById("item_2") && document.getElementById("item_2").checked;
      const item0Cost = item0Selected ? Number(this.state.selected_program.item_0_cost || 0) : 0;
      const item1Cost = item1Selected ? Number(this.state.selected_program.item_1_cost || 0) : 0;
      const item2Cost = item2Selected ? Number(this.state.selected_program.item_2_cost || 0) : 0;
      const promoCode = this.getInputValue("promotion_code").trim();
      const subtotal = planPrice + item0Cost + item1Cost + item2Cost;
      const promoDiscount = promoCode ? Math.min(subtotal * 0.1, 25) : 0;
      const total = Math.max(subtotal - promoDiscount, 0);
      const instalmentNumber = this.state.instalment_number || 1;
      const instalmentTotal = total / instalmentNumber;
      this.setState({
        dataReserve: data,
        pricingBreakdown: {
          membership_fee: 0,
          processing_fee: 0,
          plan_price: planPrice,
          total,
          instalment_total: instalmentTotal,
          instalment_number: instalmentNumber,
          extra_fees: [],
          early_bird_applied: false,
          early_bird: 0,
          promo_code: promoDiscount ? `-${promoDiscount.toFixed(2)}` : 0,
          item_0_cost: item0Cost,
          item_1_cost: item1Cost,
          item_2_cost: item2Cost,
        },
        showPricingBreakdown: true,
        continue_spinner: false,
        validationMessage: "",
      });
      return;
    }
    $.ajax({
      dataType: "json",
      url: this.state.pricingEndpoint,
      data: data,
      success: (results) => {
        this.setState({
          dataReserve: data,
          pricingBreakdown: results.message,
          showPricingBreakdown: true,
          continue_spinner: false,
          validationMessage: "",
        });
      },
      error: (err) => {
        console.log("error:", err);
      },
    });
  };

  prepareEventFilterData = () => {
    const playerEventPrograms = this.state.programs.filter((p) =>
      playerEvents.includes(p.type.toLowerCase())
    );
    const teamEventPrograms = this.state.programs.filter((p) =>
      teamEvents.includes(p.type.toLowerCase())
    );
    this.setState({
      playerEventPrograms: playerEventPrograms,
      teamEventPrograms: teamEventPrograms,
    });
  };

  applyEventFilter = (eventType) => {
    if (this.state.master_grid_readonly) {
      return;
    }
    let programs;
    switch (eventType) {
      case 0:
        programs = [];
        break;
      case 1:
        programs = this.state.playerEventPrograms.map((p) => p._id);
        break;
      case 2:
        programs = this.state.teamEventPrograms.map((p) => p._id);
        break;
    }
    this.setState({
      eventFilterType: eventType,
      filteredPrograms: programs,
      showPricingBreakdown: false,
      selected_program: null
    });
  };

  planSelectHandler = (selection) => {
    const { selected_program } = this.state;
    var instalments = [];
    selected_program.plans.forEach((plan) => {
      if (
        plan._id === selection.target.value &&
        plan.instalments &&
        plan.instalments.length !== 0
      ) {
        instalments = plan.instalments;
      }
    });
    this.setState({
      selected_plan: selection.target.value,
      instalments,
      displayPaymentForm: false,
      instalment_number: 1,
      invalidFieldIds: this.state.invalidFieldIds.filter((id) => id !== "selected_plan"),
    });
  };

  handleAthleteBirthdateChange = (value, fieldId = "athlete_birth_date") => {
    this.setState((prevState) => ({
      athlete_birth_date: value,
      showPricingBreakdown: false,
      invalidFieldIds: prevState.invalidFieldIds.filter((id) => id !== fieldId),
    }));
  };

  createPostData() {
    var planName = null;
    this.state.selected_program.plans.forEach((plan) => {
      if (plan._id === this.state.selected_plan) {
        planName = plan.plan_name;
      }
    });
    var postData = {
      organization_id: this.state.organization_id,
      team0: { program: this.state.selected_program._id },
      transaction: {
        program: {
          _id: this.state.selected_program._id,
          name: this.state.selected_program.group_name,
          type: this.state.selected_program.type,
        },
        plan: {
          _id: this.state.selected_plan,
          name: planName,
        },
        parent: {
          _id: null,
          first_name: null,
          last_name: null,
        },
        athlete: {
          _id: null,
          first_name: null,
          last_name: null,
        },
        merch: {
          item_0: document.getElementById("item_0")
            ? document.getElementById("item_0").checked
              ? document.getElementById("item_0_size").value
              : false
            : false,
          item_1: document.getElementById("item_1")
            ? document.getElementById("item_1").checked
              ? document.getElementById("item_1_size").value
              : false
            : false,
          item_2: document.getElementById("item_2")
            ? document.getElementById("item_2").checked
              ? document.getElementById("item_2_size").value
              : false
            : false,
        },
        price_breakdown: this.state.pricingBreakdown,
      },
    };
    if (this.state.clubteamUser) {
      var team_name = getParams().team_name
        ? decodeURIComponent(getParams().team_name)
        : "";
      postData.transaction.clubteam_user = true;
      postData.transaction.enrollment_number = getParams().enrollment_number;
      postData.transaction.team_name = team_name;
    }
    if (!this.state.token || this.state.createAthlete) {
      postData.athlete = {
        first_name: document.getElementById("athlete_first_name").value,
        last_name: document.getElementById("athlete_last_name").value,
        email: document.getElementById("athlete_email").value,
        type: "athlete",
        extras: {
          phone: document.getElementById("athlete_phone").value,
          date_of_birth: this.state.athlete_birth_date.toISOString(),
          gender: document.getElementById("athlete_gender").value,
          address: document.getElementById("athlete_address").value,
          postal_code: document.getElementById("athlete_postal_code").value,
          city: document.getElementById("athlete_city").value,
          province: document.getElementById("athlete_province").value,
          parent_notes: document.getElementById("athlete_parent_notes").value,
        },
      };
      postData.transaction.athlete.first_name = document.getElementById(
        "athlete_first_name"
      ).value;
      postData.transaction.athlete.last_name = document.getElementById(
        "athlete_last_name"
      ).value;
    } else {
      postData.team0.athlete = this.state.selected_athlete._id; //if create athlete is not selected
      postData.transaction.athlete._id = this.state.selected_athlete._id;
      postData.transaction.athlete.first_name = this.state.selected_athlete.first_name;
      postData.transaction.athlete.last_name = this.state.selected_athlete.last_name;
      postData.athlete = {
        first_name: document.getElementById("athlete_first_name").value,
        last_name: document.getElementById("athlete_last_name").value,
        email: document.getElementById("athlete_email").value,
        type: "athlete",
        extras: {
          phone: document.getElementById("athlete_phone").value,
          date_of_birth: this.state.athlete_birth_date.toISOString(),
          gender: document.getElementById("athlete_gender").value,
          address: document.getElementById("athlete_address").value,
          postal_code: document.getElementById("athlete_postal_code").value,
          city: document.getElementById("athlete_city").value,
          province: document.getElementById("athlete_province").value,
          parent_notes: document.getElementById("athlete_parent_notes").value,
        },
      };
    }
    if (!this.state.token) {
      postData.parent = {
        first_name: document.getElementById("parent1_first_name").value,
        last_name: document.getElementById("parent1_last_name").value,
        email: this.props.email,
        password: this.props.password,
        type: "parent",
        extras: {
          phone: document.getElementById("parent1_phone").value,
          secondary_parent: {
            first_name: document.getElementById("parent2_first_name").value,
            last_name: document.getElementById("parent2_last_name").value,
            email: document.getElementById("parent2_email").value,
            phone: document.getElementById("parent2_phone").value,
          },
        },
      };
      postData.transaction.parent.first_name = document.getElementById(
        "parent1_first_name"
      ).value;
      postData.transaction.parent.last_name = document.getElementById(
        "parent1_last_name"
      ).value;
    }

    if (this.state.programUDFs) {
      var udfs = [];
      this.state.programUDFs.forEach((udf) => {
        var udfValue = document.getElementById(udf.label).value;
        udfs.push({
          organization_id: this.state.organization_id,
          key: udf.key,
          value: udf.type.format === "number" ? +udfValue : udfValue,
        });
      });
      if (this.state.token) {
        postData.udfs = udfs;
      } else {
        postData.athlete.udfs = udfs;
      }
      // console.log('postData.athlete', postData.athlete)
    }
    return postData;
  }

  // TODO: For Stripe implementation, may not be needed
  generateConvergeToken(callback) {
    console.log("generateConvergeToken");
    if (this.state.waitlistInitialSignup || this.state.gateway === "stripe") {
      //  initial waitlist enrolment does not require converge token
      callback(true, null);
    } else {
      const { tokenGenerator, selected_program } = this.state;
      // if league, payment goes to league, not club
      const organization_id = selected_program.league_organization_id
        ? selected_program.league_organization_id
        : this.state.organization_id;
      var rthis = this;
      this.setState({ pay_spinner: true });
      console.log(
        "generateConvergeToken - tokenGenerator?",
        tokenGenerator,
        "organization_id",
        organization_id
      );
      $.ajax({
        method: "POST",
        dataType: "text",
        url: `${tokenGenerator}/${organization_id}`,
        success: (results) => {
          console.log("Token:", results);
          rthis.setState({ convergeToken: results, pay_spinner: false });
          callback(true, null);
        },
        error: (err) => {
          callback(null, { message: "Payment token error, please try again." });
        },
      });
    }
  }

  getPrice = () => {
    var rthis = this;
    this.pendingInvalidFieldIds = [];
    this.setState({ invalidFieldIds: [] });
    const selectedPlanId = this.getSelectedPlanId();
    if (!selectedPlanId) {
      this.setState({
        validationMessage: "Please check that all required fields are complete.",
        invalidFieldIds: ["selected_plan"],
      });
      return;
    }
    const hasSelectedAthlete = !!this.state.selected_athlete;
    if (this.state.token && !this.state.createAthlete && !hasSelectedAthlete) {
      this.setState({
        validationMessage: "Please select a participant.",
        invalidFieldIds: ["selected_athlete"],
      });
      const selectedAthleteField = document.getElementById("selected_athlete");
      if (selectedAthleteField && typeof selectedAthleteField.scrollIntoView === "function") {
        selectedAthleteField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (selectedAthleteField && typeof selectedAthleteField.focus === "function") {
        selectedAthleteField.focus();
      }
      return;
    }
    if (!this.checkFields("athlete")) {
      return;
    }
    if (this.state.selected_program.plans.length === 1) {
      this.setState({
        selected_plan: selectedPlanId,
      });
    }
    this.setState({ continue_spinner: true });
    var data = {
      item_0: document.getElementById("item_0")
        ? document.getElementById("item_0").checked
        : false,
      item_1: document.getElementById("item_1")
        ? document.getElementById("item_1").checked
        : false,
      item_2: document.getElementById("item_2")
        ? document.getElementById("item_2").checked
        : false,
      promo_code_key: this.getInputValue("promotion_code"),
      program_id: this.state.selected_program._id,
      instalment_number: this.state.instalment_number,
      plan_id: selectedPlanId,
    };
    console.log("ORIGINAL DATA", data);
    $.ajax({
      dataType: "json",
      url: this.state.pricingEndpoint,
      data: data,
      success: (results) => {
        console.log("in getPrice", results.message);
        this.setState({
          dataReserve: data,
          pricingBreakdown: results.message,
          showPricingBreakdown: true,
          continue_spinner: false,
          validationMessage: "",
        });
      },
      error: (err) => {
        console.log("error:", err);
        alert(
          "Cannot find price plans, please contact support@hoopstir.com"
        );
      },
    });
  };

  checkUDFFields = () => {
    const missing = (this.state.programUDFs || []).filter((udf) => {
      const field = document.getElementById(udf.label);
      return udf.required === true && (!field || field.value === "");
    });
    if (missing.length) {
      const invalidFieldIds = [
        ...new Set([
          ...(this.pendingInvalidFieldIds || []),
          ...missing.map((udf) => udf.label),
        ]),
      ];
      this.pendingInvalidFieldIds = invalidFieldIds;
      this.setState({
        validationMessage: `Please enter ${missing[0].label}.`,
        invalidFieldIds,
      });
      const firstMissingField = document.getElementById(missing[0].label);
      if (firstMissingField && typeof firstMissingField.scrollIntoView === "function") {
        firstMissingField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (firstMissingField && typeof firstMissingField.focus === "function") {
        firstMissingField.focus();
      }
      return false;
    }
    return true;
  };

  checkFields = (type) => {
    const fail = (ids) => {
      const invalidFieldIds = [
        ...new Set([...(this.pendingInvalidFieldIds || []), ...ids]),
      ];
      this.pendingInvalidFieldIds = invalidFieldIds;
      this.setState({
        validationMessage: "Please check that all required fields are complete.",
        invalidFieldIds,
      });
      return false;
    };
    const { selected_athlete, selected_program, programUDFs } = this.state;
    if (type === "athlete") {
      const athleteGender = selected_athlete
        ? selected_athlete.extras && selected_athlete.extras.gender
          ? selected_athlete.extras.gender
          : ""
        : this.getInputValue("athlete_gender");
      console.log("athleteGender", athleteGender);
      const missing = [];
      const selectedProgramDivision = selected_program ? selected_program.division : "";
      if (athleteGender === "") {
        missing.push("athlete_gender");
      } else if (
        selectedProgramDivision === "girls" &&
        athleteGender === "male"
      ) {
        missing.push("athlete_gender");
      } else if (
        selectedProgramDivision === "boys" &&
        athleteGender === "female"
      ) {
        missing.push("athlete_gender");
      }
      if (!selected_athlete) {
        if (
          this.getInputValue("athlete_email").toLowerCase() ===
          this.state.parent_email.toLowerCase()
        ) {
          missing.push("athlete_email");
        }
        if (this.getInputValue("athlete_first_name") === "") {
          missing.push("athlete_first_name");
        }
        if (this.getInputValue("athlete_last_name") === "") {
          missing.push("athlete_last_name");
        }
        if (this.state.athlete_birth_date === null) {
          missing.push("athlete_birth_date");
        }
        if (this.getInputValue("athlete_phone") === "") {
          missing.push("athlete_phone");
        }
        if (this.getInputValue("athlete_address") === "") {
          missing.push("athlete_address");
        }
        if (this.getInputValue("athlete_city") === "") {
          missing.push("athlete_city");
        }
        if (this.getInputValue("athlete_province") === "") {
          missing.push("athlete_province");
        }
        if (this.getInputValue("athlete_postal_code") === "") {
          missing.push("athlete_postal_code");
        }
      }
      if (missing.length) {
        return fail(missing);
      }
      if (programUDFs) {
        var udfCheck = this.checkUDFFields();
        return udfCheck;
      }
    } else if (type === "parent") {
      const missing = [];
      if (this.getInputValue("parent1_first_name") === "") {
        missing.push("parent1_first_name");
      }
      if (this.getInputValue("parent1_last_name") === "") {
        missing.push("parent1_last_name");
      }
      if (this.getInputValue("parent1_phone") === "") {
        missing.push("parent1_phone");
      }
      if (this.getInputValue("parent2_first_name") === "") {
        missing.push("parent2_first_name");
      }
      if (this.getInputValue("parent2_last_name") === "") {
        missing.push("parent2_last_name");
      }
      if (this.getInputValue("parent2_email") === "") {
        missing.push("parent2_email");
      }
      if (this.getInputValue("parent2_phone") === "") {
        missing.push("parent2_phone");
      }
      if (missing.length) {
        return fail(missing);
      }
      return true;
    }
    return true;
  };

  requestToken(transaction_id) {
    var rthis = this;
    $.ajax({
      url: this.state.loginEndpoint,
      type: "GET",
      dataType: "json",
      headers: {
        function: "check_password_correct",
        email: this.props.email,
        password: this.props.password,
        organization_id: this.state.organization_id,
      },
      success: function (data) {
        if (data.errorMessage) {
          alert(
            "Unable to identify the user, please email support@hoopstir.com."
          );
        } else {
          if (rthis.state.waitlistInitialSignup) {
            rthis.setState({
              transaction_id: transaction_id,
              displayPaymentForm: true,
              token: data.message,
              confirm_spinner: false,
              paymentStatus: "waitlist",
            });
          } else if (rthis.state.pricingBreakdown.total === 0) {
            rthis.setState({ token: data.message });
            var response = total0Recept();
            rthis.patchReceipt(transaction_id, response);
          } else {
            rthis.setState({
              transaction_id: transaction_id,
              displayPaymentForm: true,
              confirm_spinner: false,
              token: data.message,
            });
          }
        }
      },
      error: function (data) {
        alert(
          "Server error while getting user token, please email support@hoopstir.com."
        );
      },
    });
  }

  // TODO: This function submits the payment info to converge
  pay = (card, exp_year, exp_month, cvv) => {
    // console.log("GRABBING=", card, exp_year, exp_month, cvv)
    this.setState({ pay_spinner: true });
    console.log("DATA RESERVED", this.state.dataReserve);
    console.log(this.state.pricingEndpoint, "data");
    var rthis = this;
    var token = this.state.convergeToken;
    var transaction_id = this.state.transaction_id;
    const normalizedTransactionId = transaction_id ? `${transaction_id}` : '';
    var email = this.state.parent_email;
    var firstName = this.state.parent.first_name;
    var lastName = this.state.parent.last_name;

    console.log("IN PAY FN - TOKEN", token);
    console.log("HITTING PAY FUNCTION", this.state.transaction_id);
    var paymentData = {
      ssl_txn_auth_token: token,
      ssl_card_number: card,
      ssl_exp_date: `${exp_month}${exp_year}`,
      ssl_cvv2cvc2: cvv,
      ssl_email: email,
      ssl_first_name: firstName,
      ssl_last_name: lastName,
      ssl_invoice_number: normalizedTransactionId,
    };
    console.log("IN PAY FN - paymentData", paymentData);
    if (this.state.pricingBreakdown.instalment_number === 1) {
      paymentData.ssl_amount = Number(this.state.pricingBreakdown.total || 0).toFixed(2);
    } else {
      let formattedDate = mmddyyyyDateFormat(new Date());
      paymentData.ssl_amount = Number(this.state.pricingBreakdown.instalment_total || 0).toFixed(2);
      paymentData.ssl_transaction_type = "ccaddinstall";
      paymentData.ssl_total_installments = this.state.instalment_number;
      paymentData.ssl_billing_cycle = "MONTHLY";
      paymentData.ssl_next_payment_date = `${formattedDate}`;
      if (
        formattedDate.slice(3, 5) == "28" ||
        formattedDate.slice(3, 5) == "29" ||
        formattedDate.slice(3, 5) == "30" ||
        formattedDate.slice(3, 5) == "31"
      ) {
        paymentData.ssl_end_of_month = "Y";
      }
    }

    console.log("PAYMENT DATA", paymentData);

    var callback = {
      onError: function (error) {
        console.log(
          "Something went wrong.  Please refresh the page and try again - response",
          error
        );
        const errorDetail =
          error && typeof error === "object"
            ? error.errorMessage || error.message || JSON.stringify(error)
            : `${error || ""}`;
        alert(
          `Something went wrong.  Please refresh the page and try again.${errorDetail ? `\n${errorDetail}` : ""}`
        )
        rthis.setState({ paymentStatus: "error", pay_spinner: false });
      },
      onDeclined: function (response) {
        console.log(
          "Your payment was declined, Please try again - response",
          response
        );
        alert("Your payment was declined, Please try again")
        rthis.setState({ paymentStatus: "declined", pay_spinner: false });
      },
      onApproval: (response) => {
        rthis.patchReceipt(transaction_id, response);
      },
    };
    console.log("GOING TO ConvergeEmbeddedPayments");
    window.ConvergeEmbeddedPayment.pay(paymentData, callback);
  };

  stripeDecline = () => {
    alert("Your payment was unsuccessful.  Please try again.");
    this.setState({ paymentStatus: "declined", pay_spinner: false });
  };

  patchReceipt = (transaction_id, receipt) => {
    var rthis = this;
    var data = {};
    console.log(this.state.transaction_id, "trans here?????");
    data.receipt = receipt;
    data.receipt.transaction_id =
      this.state.gateway === "stripe"
        ? `${this.state.transaction_id}`
        : `${transaction_id}`;
    data.transaction_id = `${transaction_id}`;
    data.club_id = this.state.organization_id;
    data.gateway = this.state.gateway;
    if (this.state.waitlistTransaction) {
      data.waitlist_update = true;
        data.merch = {
          item_0: document.getElementById("item_0")
            ? document.getElementById("item_0").checked
              ? this.getInputValue("item_0_size")
              : false
            : false,
          item_1: document.getElementById("item_1")
            ? document.getElementById("item_1").checked
              ? this.getInputValue("item_1_size")
              : false
            : false,
          item_2: document.getElementById("item_2")
            ? document.getElementById("item_2").checked
              ? this.getInputValue("item_2_size")
              : false
            : false,
        };
      data.price_breakdown = this.state.pricingBreakdown;
    } else if (this.state.clubteamUser) {
      data.clubteam_user = true;
    }
    console.log("DATA SENT TO CALL", data);
    $.ajax({
      headers: {
        token: this.state.token,
      },
      method: "PATCH",
      contentType: "application/json",
      data: JSON.stringify(data),
      url: this.state.transactionEndpoint,
      success: function (data) {
        console.log("DATA ON RECEIPT", data);

        if (data.errorMessage) {
          alert(data.errorMessage);
        } else {
          if (rthis.state.pricingBreakdown.total === 0) {
            rthis.setState({
              displayPaymentForm: true,
              confirm_spinner: false,
              paymentStatus: "approved",
            });
          } else {
            rthis.setState({
              paymentStatus: "approved",
              pay_spinner: false,
            });
          }
        }
      },
      error: function (data) {
        console.log("DATA ON RECEIPT ERR", data);
        alert(
          "The transaction was successful but there was an error with the registration.  Please email support@hoopstir.com" +
            "\n" +
            "error: " +
            data.status
        );
        rthis.setState({ confirm_spinner: false });
      },
    });
  };

  handleApprovedSignOut = () => {
    window.location.href =
      document.location.origin + "/logout?jwt=" + this.state.token;
  };

  handleApprovedRedirect = () => {
    window.location.href =
      document.location.origin +
      "/portals?jwt=" +
      this.state.token +
      "&protalMode=parent";
  };

  displayPaymentForm = () => {
    const {
      waitlistTransaction,
      pricingBreakdown,
      transaction_id,
      organization_id,
      selected_program,
    } = this.state;
    this.pendingInvalidFieldIds = [];
    this.setState({ validationMessage: "", invalidFieldIds: [] });
    const hasSelectedAthlete = !!this.state.selected_athlete;
    if (this.state.token && !this.state.createAthlete && !hasSelectedAthlete) {
      this.setState({
        validationMessage: "Please select a participant.",
        invalidFieldIds: ["selected_athlete"],
      });
      return;
    }
    const requiredFieldsOk = this.state.token
      ? this.state.createAthlete || hasSelectedAthlete
        ? this.checkFields("athlete")
        : true
      : (() => {
          const parentOk = this.checkFields("parent");
          const athleteOk = this.checkFields("athlete");
          return parentOk && athleteOk;
        })();

    if (!requiredFieldsOk) {
      return;
    }
    const terms = document.getElementById("terms_checked");
    if (!terms || !terms.checked) {
      this.setState({
        validationMessage: "Please check the waiver box before continuing.",
        invalidFieldIds: [
          ...new Set([...(this.pendingInvalidFieldIds || []), "terms_checked"]),
        ],
      });
      return;
    }
    if (waitlistTransaction) {
      this.setState({ disabled: true, confirm_spinner: true });
      var rthis = this;
      console.log("waitlist get transaction");
      $.ajax({
        url: this.state.transactionEndpoint,
        type: "GET",
        headers: {
          token: this.state.token,
          program_id: waitlistTransaction.program._id,
          organization_id: organization_id,
          enrolment_flex: true,
        },
        contentType: "application/json",
        success: function (data) {
          if (data && data.errMessage) {
            alert(data.errMessage);
            window.location.href =
              document.location.origin +
              "/enrollmentform?jwt=" +
              rthis.state.token +
              "&organization_id=" +
              rthis.state.organization_id;
          } else {
            console.log("data", data);
            if (rthis.state.pricingBreakdown.total === 0) {
              var response = total0Recept();
              rthis.patchReceipt(transaction_id, response);
            } else {
              rthis.generateConvergeToken((token, err) => {
                if (err) {
                  alert(err.message);
                  rthis.setState({
                    disabled: false,
                    confirm_spinner: false,
                  });
                  return;
                }
                rthis.setState({
                  displayPaymentForm: true,
                  confirm_spinner: false,
                  transaction_id,
                });
              });
            }
          }
        },
        error: function (data) {
          alert("Error connecting server, please contact support.");
          rthis.setState({ confirm_spinner: false });
        },
      });
    } else {
      this.setState({ disabled: true, confirm_spinner: true });
      var data = this.createPostData();
      if (selected_program.league_organization_id) {
        data.league_organization_id = selected_program.league_organization_id;
      }
      data.transaction.status = "unverified";
      this.setState({master_grid_readonly: true});
      console.log("posting to enrolment. Data:", data, JSON.stringify(data));
      var rthis = this;
      $.ajax({
        url: this.state.endpoint,
        type: "POST",
        data: JSON.stringify(data),
        headers: {
          token: this.state.token,
          organization_id: this.state.organization_id,
        },
        contentType: "application/json",
        success: function (data) {
          console.log("DATA", data);
          if (data && data.errorMessage) {
            console.log("HERE AT MESSAGE", data);
            alert(data.errorMessage);
            rthis.setState({ disabled: false, confirm_spinner: false });
          } else {
            var transaction_id = data.message;
            if (!rthis.state.token) {
              var parent = {
                first_name: document.getElementById("parent1_first_name").value,
                last_name: document.getElementById("parent1_last_name").value,
              };
              rthis.setState({ parent: parent });
              rthis.requestToken(transaction_id);
            } else {
              if (rthis.state.pricingBreakdown.total === 0) {
                var response = total0Recept();
                rthis.patchReceipt(transaction_id, response);
              } else {
                rthis.generateConvergeToken((token, err) => {
                  if (err) {
                    alert(err.message);
                    rthis.setState({
                      disabled: false,
                      confirm_spinner: false,
                      validationMessage: "",
                    });
                    return;
                  }
                  rthis.setState({
                    transaction_id: transaction_id,
                    displayPaymentForm: true,
                    confirm_spinner: false,
                    validationMessage: "",
                  });
                });
              }
            }
          }
        },
        error: function (data) {
          alert("Error enrolling the user, please contact support!");
        },
      });
    }
  };

  joinWaitlist = () => {
    if (window.confirm(`Press OK to join the waitlist.  You will not be charged at this time.`)) {
      this.setState({ disabled: true, confirm_spinner: true });
      var data = this.createPostData();
      data.transaction.status = "waitlist";
      var rthis = this;
      $.ajax({
        url: this.state.endpoint,
        type: "POST",
        data: JSON.stringify(data),
        headers: {
          token: this.state.token,
          organization_id: this.state.organization_id,
        },
        contentType: "application/json",
        success: function (data) {
          if (data && data.errorMessage) {
            console.log("waitlist - data.errorMessage", data.errorMessage);
            alert(data.errorMessage);
            rthis.setState({ disabled: false, confirm_spinner: false });
          } else {
            console.log("Waitlist data.message", data.message);
            var transaction_id = data.message;
            if (!rthis.state.token) {
              rthis.requestToken(transaction_id);
            } else {
              rthis.setState({
                transaction_id: transaction_id,
                displayPaymentForm: true,
                confirm_spinner: false,
                paymentStatus: "waitlist",
              });
            }
          }
        },
        error: function (data) {
          alert("Error saving the user to waitlist, please contact support@hoopstir.com");
        },
      });
    }
  };

  handleRefresh = () => {
    window.location.href =
      document.location.origin +
      "/enrollmentform?jwt=" +
      this.state.token +
      "&organization_id=" +
      this.state.organization_id;
  };

  onInstalmentClick = (e) => {
    this.setState({
      instalment_number: +e.target.value,
    });
  };

  changeState = (fieldId, fieldValue) => {
    const hasValue =
      fieldValue !== undefined &&
      fieldValue !== null &&
      `${fieldValue}`.trim() !== "";

    if (!fieldId) {
      return;
    }

    this.pendingInvalidFieldIds = [];
    this.setState((prevState) => ({
      invalidFieldIds: hasValue
        ? prevState.invalidFieldIds.filter((id) => id !== fieldId)
        : prevState.invalidFieldIds,
    }));
  };

  setSpinner = () => {
    this.setState({ pay_spinner: !this.state.pay_spinner });
  };

  isTeamEvent = () => {
    return teamEvents.includes(this.state.selected_program.type.toLowerCase())
  }

  render() {
    const {
      waitlist,
      waitlistInitialSignup,
      waitlistTransaction,
      selected_program,
      instalments,
      instalment_number,
      clubteamUser,
      disabled,
      organization_merch,
      programs,
      pricingBreakdown,
      programUDFs,
      selected_athlete,
      token,
      selected_plan,
    } = this.state;

    var rthis = this;
    var item_0_options = [];
    var item_1_options = [];
    var item_2_options = [];
    var previewCustomFields = [
      {
        key: "preferred_name",
        label: "Preferred Name",
        required: false,
        type: { format: "text" },
      },
      {
        key: "player_goal",
        label: "Primary Goal",
        required: false,
        type: {
          format: "list",
          values: ["Skill Development", "Fun", "Team Play", "Fitness"],
        },
      },
      {
        key: "shirt_size",
        label: "Shirt Size",
        required: false,
        type: {
          format: "list",
          values: ["Youth S", "Youth M", "Youth L", "Adult S", "Adult M", "Adult L"],
        },
      },
      {
        key: "emergency_contact",
        label: "Emergency Contact Phone",
        required: false,
        type: { format: "text" },
      },
    ];
    var noMerch =
      selected_program &&
      selected_program.item_0_cost === null &&
      selected_program.item_1_cost === null &&
      selected_program.item_2_cost === null &&
      true;
    var showMerchandiseSection =
      this.state.previewFullForm ||
      (selected_program &&
        !noMerch);

    let payment_field =
      this.state.previewFullForm ? (
        <div className="enrolment-payment-card enrolment-payment-preview">
          <div className="enrolment-section-placeholder">
            Preview mode only. This is the payment form layout without a live submission.
          </div>
          <div className="enrolment-payment-grid">
            <FormGroup>
              <ControlLabel>Credit Card Number</ControlLabel>
              <FormControl
                className="enrolment-payment-preview-input"
                type="text"
                value="4111 1111 1111 1111"
                readOnly
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Expiry Month</ControlLabel>
              <FormControl
                className="enrolment-payment-preview-input"
                type="text"
                value="12"
                readOnly
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Expiry Year</ControlLabel>
              <FormControl
                className="enrolment-payment-preview-input"
                type="text"
                value="30"
                readOnly
              />
            </FormGroup>
          </div>
          <div className="enrolment-payment-preview-input-group">
            <FormGroup>
              <ControlLabel>CVV</ControlLabel>
              <FormControl
                className="enrolment-payment-preview-input"
                type="text"
                value="123"
                readOnly
              />
            </FormGroup>
            <div style={{ display: "flex", alignItems: "end" }}>
              <Button className="orange-fill pay-button enrolment-payment-preview-button" disabled>
                Pay Now
              </Button>
            </div>
          </div>
        </div>
      ) : this.state.gateway === "stripe" ? (
        <StripePaymentGateway
          currencyType={this.state.currencyType}
          pricingBreakdown={pricingBreakdown}
          patchReceipt={this.patchReceipt}
          paymentStatus={this.state.paymentStatus}
          pay_spinner={this.state.pay_spinner}
          setSpinner={this.setSpinner}
          selected_program={this.state.selected_program}
          pay={this.pay}
          email={this.state.parent_email}
          name={this.state.name}
          handleRefresh={this.handleRefresh}
          handleApprovedSignOut={this.handleApprovedSignOut}
          handleApprovedRedirect={this.handleApprovedRedirect}
          stripeEndPoint={this.state.stripeEndPoint}
          stripeDecline={this.stripeDecline}
          account={this.state.stripe_account}
        />
      ) : (
        <ConvergePaymentGateway
          noMerch={noMerch}
          email={this.props.email}
          handleRefresh={this.handleRefresh}
          handleApprovedSignOut={this.handleApprovedSignOut}
          handleApprovedRedirect={this.handleApprovedRedirect}
          paymentStatus={this.state.paymentStatus}
          pay_spinner={this.state.pay_spinner}
          selected_program={selected_program}
          pay={this.pay}
          ageVerify={
            selected_program && selected_program.ageVerify
              ? selected_program.ageVerify
              : null
          }
        />
      );

    if (organization_merch.length > 0) {
      if (waitlistTransaction) {
        organization_merch[0].size.forEach((size) => {
          waitlistTransaction.merch.item_0 === size
            ? item_0_options.push(
                <option checked value={size}>
                  {size}
                </option>
              )
            : item_0_options.push(
                <option value={size} key={size}>
                  {size}
                </option>
              );
        });
        organization_merch[1].size.forEach((size) => {
          waitlistTransaction.merch.item_1 === size
            ? item_1_options.push(
                <option checked value={size}>
                  {size}
                </option>
              )
            : item_1_options.push(
                <option value={size} key={size}>
                  {size}
                </option>
              );
        });
        organization_merch[2].size.forEach((size) => {
          waitlistTransaction.merch.item_2 === size
            ? item_2_options.push(
                <option checked value={size}>
                  {size}
                </option>
              )
            : item_2_options.push(
                <option value={size} key={size}>
                  {size}
                </option>
              );
        });
      } else {
        const merch0Sizes =
          organization_merch[0] && Array.isArray(organization_merch[0].size)
            ? organization_merch[0].size
            : [];
        const merch1Sizes =
          organization_merch[1] && Array.isArray(organization_merch[1].size)
            ? organization_merch[1].size
            : [];
        const merch2Sizes =
          organization_merch[2] && Array.isArray(organization_merch[2].size)
            ? organization_merch[2].size
            : [];

        merch0Sizes.forEach((size) => {
          item_0_options.push(
            <option value={size} key={size}>
              {size}
            </option>
          );
        });
        merch1Sizes.forEach((size) => {
          item_1_options.push(
            <option value={size} key={size}>
              {size}
            </option>
          );
        });
        merch2Sizes.forEach((size) => {
          item_2_options.push(
            <option value={size} key={size}>
              {size}
            </option>
          );
        });
      }
    }

    var programsList = [];
    if (programs.length > 0) {
      var team_name = getParams().team_name
        ? decodeURIComponent(getParams().team_name)
        : "";
      programs.forEach((program) => {
        var division =
          program.division.charAt(0).toUpperCase() + program.division.slice(1);
        if (program.division === "co-ed") {
          division = "Co-Ed";
        }
        if (
          (window.matchMedia("(max-width: 750px)").matches &&
            navigator.platform === "iPhone") ||
          navigator.platform === "iPad"
        ) {
          programsList.push(
            <label
              className={
                (selected_program && program._id === selected_program._id) ||
                program._id === this.props.preSelectedProgram
                  ? "white-text program-option checked"
                  : "white-text program-option"
              }
              style={{ width: "100%" }}
              onClick={() => this.programSelectedhandler(program._id)}
              value={program._id}
              key={program._id}
            >
              {program.ages} | {division} | {program.group_name}{" "}
              {team_name ? `[${team_name}] ` : ""}
            </label>
          );
        } else {
          programsList.push(
            <option
              className="white-text program-option"
              value={program._id}
              key={program._id}
              selected={
                selected_program
                  ? program._id === selected_program._id
                  : program._id === this.props.preSelectedProgram
              }
            >
              {program.ages} | {division} | {program.group_name}{" "}
              {team_name ? `[${team_name}] ` : ""}
            </option>
          );
        }
      });
    } else if (this.state.loading) {
      programsList.push(
        <option
          className="white-text program-option"
          value={"select"}
          key={0}
          disabled
          selected
        >
          Loading...
        </option>
      );
    } else {
      programsList.push(
        <option
          className="white-text program-option"
          value={"select"}
          key={1}
          disabled
          selected
        >
          Enrolment is Closed
        </option>
      );
    }

    var plans = [];
    if (selected_program) {
      if (waitlistTransaction) {
        plans.push(
          <option
            key={waitlistTransaction.plan._id}
            value={waitlistTransaction.plan._id}
            selected
          >
            {waitlistTransaction.plan.name} - $
            {waitlistTransaction.price_breakdown.plan_price}{" "}
            {instalments.length !== 0 ? "*monthly instalment available" : ""}
          </option>
        );
      } else {
        selected_program.plans.forEach((plan) => {
          plans.push(
            <option key={plan._id} value={plan._id}>
              {plan.plan_name} - ${plan.plan_price}{" "}
              {plan.instalments && plan.instalments.length !== 0
                ? "*monthly instalment available"
                : ""}
            </option>
          );
        });
      }
    }

    var athletes = [];
    if (this.state.athletes !== undefined && this.state.athletes.length > 0) {
      this.state.athletes.forEach((athlete) => {
        athletes.push(
          <option key={makeUniqueKey()} value={athlete._id} key={athlete._id}>
            {athlete.first_name} {athlete.last_name}
          </option>
        );
      });
    }

    var program_details = [];
    if (selected_program) {
      var division =
        selected_program.division.charAt(0).toUpperCase() +
        selected_program.division.slice(1);
      if (selected_program.division === "co-ed") {
        division = "Co-Ed";
      }
      var sessions = [];
      sortProgramSessions(selected_program.sessions).forEach((session) => {
        sessions.push(
          <tr key={makeUniqueKey()} style={{backgroundColor: "#3747A5"}}>
            <td style={{ width: "20%" }}>{formatSessionDateLabel(session)}</td>
            <td style={{ width: "15%" }}>{session.start_time}</td>
            <td style={{ width: "15%" }}>{session.end_time}</td>
            <td style={{ width: "25%" }}>{session.type}</td>            
            <td style={{ width: "25%" }}>{session.location}</td>
          </tr>
        );
      });
      var status =
        selected_program.status === "waitlist" ? "WAITLIST OPEN" : "OPEN";
      team_name = getParams().team_name
        ? decodeURIComponent(getParams().team_name)
        : "";

      program_details.push(
        <ProgramDetails
          key={makeUniqueKey()}
          selected_program={selected_program}
          team_name={team_name}
          division={division}
          status={status}
          sessions={sessions}
          plans={plans}
          selected_plan={this.state.selected_plan}
          planSelectHandler={this.planSelectHandler}
          disabled={disabled}
          invalidFieldIds={this.state.invalidFieldIds}
          showForm={this.state.showForm}
          continueSpinner={this.state.continue_0_spinner}
          onContinue={this.showFormFields}
          hideNotes
        />
      );
    }

   

    var athlete_selector = [];
    if (token) {
      if (waitlistTransaction || clubteamUser) {
        athlete_selector.push(

          <>
            <div className="enrolment-section-header">
              <div className="enrolment-section-kicker">Add Participant</div>
            </div>
            <div className="enrolment-section-body enrolment-section-body-tight">
              <Row className="enrolment-row">
                <Col lg={6} xs={12} style={{ paddingLeft: "0" }}>
                  <FormGroup className={`program-detail-plan-picker program-detail-plan-picker-below ${this.state.invalidFieldIds.includes("selected_athlete") ? "enrolment-invalid-field" : ""}`}>
                    <FormControl
                      className="opaque-grey program-detail-plan-select"
                      id="selected_athlete"
                      value={this.state.selected_athlete ? this.state.selected_athlete._id : ""}
                      onChange={(e) => this.athleteSelectHandler(e)}
                      componentClass="select"
                      disabled={disabled}
                    >
                      <option value="" disabled>
                        select...
                      </option>
                      <option value="create_new_user">Add New</option>
                      {athletes}
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
            </div>
            </>

        );
      } else {

        athlete_selector.push(

          <>
            <div className="enrolment-section-header">
              <div className="enrolment-section-kicker">Add Participant</div>
            </div>
            <div className="enrolment-section-body enrolment-section-body-tight">
              <Row className="enrolment-row">   
              <Col lg={6} xs={12} style={{ paddingLeft: "0" }}>                
                <FormGroup className={`program-detail-plan-picker program-detail-plan-picker-below ${this.state.invalidFieldIds.includes("selected_athlete") ? "enrolment-invalid-field" : ""}`}>
                  <FormControl
                    className="opaque-grey program-detail-plan-select"
                    id="selected_athlete"
                    value={this.state.selected_athlete ? this.state.selected_athlete._id : ""}
                    onChange={(e) => this.athleteSelectHandler(e)}
                    componentClass="select"
                    disabled={disabled}
                  >
                    <option value="" disabled>
                      select...
                    </option>
                    <option value="create_new_user">Add New</option>
                    {athletes}
                  </FormControl>
                </FormGroup>
              </Col>
              </Row>
            </div>
            </>

        );
      }
    }

    var account_info = [];
    if (!token) {
      account_info.push(
        <AccountInfo
          disabled={disabled}
          parentEmail={this.state.parent_email}
          changeState={this.changeState}
          invalidFieldIds={this.state.invalidFieldIds}
        />
      );
    }

    var customFields =
      programUDFs && programUDFs.length > 0
        ? programUDFs
        : this.state.previewFullForm
        ? previewCustomFields
        : null;

    var athlete_info = [];
    if (!token || this.state.createAthlete || this.state.selected_athlete) {
      athlete_info.push(
        <AthleteInfo
          disabled={disabled}
          athlete_birth_date={this.state.athlete_birth_date}
          handleAthleteBirthdateChange={this.handleAthleteBirthdateChange}
          changeState={this.changeState}
          invalidFieldIds={this.state.invalidFieldIds}
          customFields={customFields}
            selected_athlete={selected_athlete}
        />
      );
    }

    var promotion_code_field = [];
    if (
      this.state.selected_plan ||
      (selected_program && selected_program.plans.length === 1)
    ) {
      if (waitlistTransaction) {
        promotion_code_field.push(

            <FormGroup
            >
              <FormControl
                className="opaque-grey"
                type="text"
                id="promotion_code"
                placeholder=""
                onChange={this.resetPricingBreakdown}
                value={waitlistTransaction.price_breakdown.promo_code_key}
                disabled={disabled}
              />
            </FormGroup>

        );
      } else {
        promotion_code_field.push(

            <FormGroup
            >
              <FormControl
                className="opaque-grey"
                type="text"
                id="promotion_code"
                placeholder=""
                onChange={this.resetPricingBreakdown}
                disabled={disabled}
              />
            </FormGroup>

        );
      }
    }

    var waiver_field = (
      <div className={`enrolment-checkout-waiver-row ${this.state.invalidFieldIds.includes("terms_checked") ? "enrolment-invalid-field" : ""}`}>
        <div className="enrolment-checkout-waiver-copy">
          <Row className="terms-row">
            <Checkbox
              id="terms_checked"
              inline
              disabled={this.state.checkBoxDisabled}
              onChange={(e) => this.handleWaiverChange(e.target.checked)}
            >
              <a
                className="white-text orange-hover"
                onClick={this.handleWaiverModal}
              >
                I have read the {" "}
                <span style={{ textDecoration: "underline" }}>
                  waiver
                </span>{" "}
                for{" "}
                {selected_program
                  ? selected_program.group_name
                  : ""}
              </a>
            </Checkbox>
          </Row>
        </div>
      </div>
    );

    var merchandise_fields = [];
    waitlistTransaction
      ? merchandise_fields.push(
          <WaitlistTransactionFields
            key={0}
            selected_program={selected_program}
            organization_merch={this.state.organization_merch}
            disabled={disabled}
            item_0_options={item_0_options}
            item_1_options={item_1_options}
            item_2_options={item_2_options}
            waitlistTransaction={this.state.waitlistTransaction}
            resetPricingBreakdown={this.resetPricingBreakdown}
          />
        )
      : merchandise_fields.push(
          <NoWaitlistTransFields
            key={1}
            selected_program={selected_program}
            organization_merch={this.state.organization_merch}
            disabled={disabled}
            item_0_options={item_0_options}
            item_1_options={item_1_options}
            item_2_options={item_2_options}
            waitlistTransaction={this.state.waitlistTransaction}
            resetPricingBreakdown={this.resetPricingBreakdown}
          />
        );

    var submission = [];
    if (this.state.showPricingBreakdown) {
      var priceElements = [];
      if (pricingBreakdown.membership_fee !== 0) {
        priceElements.push(
          <tr key={makeUniqueKey()}>
            <td className="price-breakdown-label-cell">Membership fee</td>
            <td className="price-element price-breakdown-value-cell">
              ${pricingBreakdown.membership_fee}
            </td>
          </tr>
        );
      }
      if (pricingBreakdown.extra_fees) {
        var extraFees = [];
        pricingBreakdown.extra_fees.forEach((fee) => {
          for (var extra in fee) {
            extraFees.push(
              <tr key={makeUniqueKey()}>
                <td className="price-breakdown-label-cell">{extra.split("_").join(" ")}</td>
                <td className="price-element price-breakdown-value-cell">${fee[extra]}</td>
              </tr>
            );
          }
        });
        priceElements = [priceElements, ...extraFees];
      }
      if (pricingBreakdown.early_bird_applied) {
        priceElements.push(
          <tr key={makeUniqueKey()}>
            <td className="price-breakdown-label-cell">Early Bird Discount</td>
            <td className="price-breakdown-value-cell">{this.state.pricingBreakdown.early_bird}</td>
          </tr>
        );
      }
      if (this.getInputValue("promotion_code")) {
        priceElements.push(
          <tr key={makeUniqueKey()}>
            <td className="price-breakdown-label-cell">Promotion Code Discount</td>
            <td className="price-breakdown-value-cell">{pricingBreakdown.promo_code}</td>
          </tr>
        );
      }
      if (
        document.getElementById("item_0") &&
        document.getElementById("item_0").checked &&
        this.state.organization_merch[0]
      ) {
        priceElements.push(
          <tr key={makeUniqueKey()}>
            <td className="price-breakdown-label-cell">
              {this.state.organization_merch[0].name} Cost&nbsp;-&nbsp;
              {document.getElementById("item_0_size").value}
            </td>
            <td className="price-element price-breakdown-value-cell">${pricingBreakdown.item_0_cost}</td>
          </tr>
        );
      }
      if (
        document.getElementById("item_1") &&
        document.getElementById("item_1").checked &&
        this.state.organization_merch[1]
      ) {
        priceElements.push(
          <tr key={makeUniqueKey()}>
            <td className="price-breakdown-label-cell">
              {this.state.organization_merch[1].name} Cost&nbsp;-&nbsp;
              {document.getElementById("item_1_size").value}
            </td>
            <td className="price-element price-breakdown-value-cell">${pricingBreakdown.item_1_cost}</td>
          </tr>
        );
      }
      if (
        document.getElementById("item_2") &&
        document.getElementById("item_2").checked &&
        this.state.organization_merch[2]
      ) {
        priceElements.push(
          <tr key={makeUniqueKey()}>
            <td className="price-breakdown-label-cell">
              {this.state.organization_merch[2].name} Cost&nbsp;-&nbsp;
              {document.getElementById("item_2_size").value}
            </td>
            <td className="price-element price-breakdown-value-cell">${pricingBreakdown.item_2_cost}</td>
          </tr>
        );
      }

      submission.push(
        <PriceBreakdown
          selected_program={selected_program}
          pricingBreakdown={this.state.pricingBreakdown}
          displayPaymentForm={this.state.displayPaymentForm}
          paymentField={payment_field}
          confirm_spinner={this.state.confirm_spinner}
          joinWaitlist={this.joinWaitlist}
          displayPaymentFormFn={this.displayPaymentForm}
          validationMessage={this.state.validationMessage}
          priceElements={priceElements}
          instalment_number={instalment_number}
          waitlistInitialSignup={waitlistInitialSignup}
          waitlistTransaction={waitlistTransaction}
          promotionCodeField={promotion_code_field.length > 0 ? promotion_code_field : null}
          waiverField={waiver_field}
        />
      );
    } else {
      submission.push(
        <Col sm={12} className="price-breakdown-continue-col">
          {this.state.continue_spinner ? (
            <div className="enrolment-loader"></div>
          ) : (
            <div className="price-breakdown-action-row">
              <Button
                className="button2"
                type="button"
                onClick={this.getPrice}
              >
                {waitlistInitialSignup && !waitlistTransaction
                  ? "Continue to Waitlist"
                  : "Continue"}
              </Button>
            </div>
          )}
        </Col>
      );
    }
    return (
      // TODO: This API key needs to be pulled in on a client-by-client basis
      <StripeProvider apiKey={this.state.stripeKey}>
        <div style={{ height: "100%" }}>
          {token ? (
            <HamburgerNavbar
              organization_id={this.state.organization_id}
              token={token}
            />
          ) : (
            <OrganizationBar
              organization_id={this.state.organization_id}
              organization_name={this.state.organization_name}
            />
          )}
          <div className="body-wrapper">
            {/* <form> */}
              <Col lg={12} sm={12} xs={12}>
                <Row>
                  <Col sm={12} style={{paddingRight: this.state.pageSectionsRightPadding}}>
                  <ControlLabel className="control-lbl-1">
                      Registration Form
                    </ControlLabel>
                    {
                      <>
                        {/*<div class="programList__container">*/}
                        {/*  <ul className={"programList__nav"}>*/}
                        {/*    <li className={"programList__nav__list"}>*/}
                        {/*      <a*/}
                        {/*        className={`programList__filter ${*/}
                        {/*          this.state.eventFilterType === 0 && !this.state.master_grid_readonly*/}
                        {/*            ? "selected"*/}
                        {/*            : ""*/}
                        {/*        } ${this.state.master_grid_readonly ? 'disabled': ''}`}*/}
                        {/*        onClick={() => this.applyEventFilter(0)}*/}
                        {/*      >*/}
                        {/*        {`All (${this.state.programs.length})`}*/}
                        {/*      </a>*/}
                        {/*      <a*/}
                        {/*        className={`programList__filter ${*/}
                        {/*          this.state.eventFilterType === 1 && !this.state.master_grid_readonly*/}
                        {/*            ? "selected"*/}
                        {/*            : ""*/}
                        {/*        } ${this.state.master_grid_readonly ? 'disabled': ''}`}*/}
                        {/*        onClick={() => this.applyEventFilter(1)}*/}
                        {/*      >*/}
                        {/*        {`Player Events (${this.state.playerEventPrograms.length})`}*/}
                        {/*      </a>*/}
                        {/*      <a*/}
                        {/*        className={`programList__filter ${*/}
                        {/*          this.state.eventFilterType === 2 && !this.state.master_grid_readonly*/}
                        {/*            ? "selected"*/}
                        {/*            : ""*/}
                        {/*        } ${this.state.master_grid_readonly ? 'disabled': ''}`}*/}
                        {/*        onClick={() => this.applyEventFilter(2)}*/}
                        {/*      >*/}
                        {/*        {`Team Events (${this.state.teamEventPrograms.length})`}*/}
                        {/*      </a>*/}
                        {/*    </li>*/}
                        {/*  </ul>*/}
                        {/*</div>*/}
                        <div
                          className="dashboard-box programs-container"
                          style={{ overflow: "auto", padding: "0" }}
                        >
                          <programs-api
                            id="programslist"
                            filtered_program_ids={JSON.stringify(
                              this.state.filteredPrograms
                            )}
                            organization_id={this.state.organization_id}
                            organization_name=""
                            grid_heading_background_color="var(--org-primary-color, #5563b8)"
                            grid_heading_font_color="var(--org-primary-text-color, #ffffff)"
                            grid_heading_selected_column_font_color="var(--org-primary-contrast-color, #ffffff)"
                            program_grid_selected_font_color="var(--org-primary-contrast-color, #ffffff)"
                            program_detail_header_background_color="#152073"
                            program_detail_header_font_color="var(--org-primary-text-color, #ffffff)"
                            cta_link_analytics_override=""
                            cta_background_color="var(--org-primary-color, #5563b8)"
                            cta_font_color="#fff"
                            cta_hover_border_color="#F7A601"
                            cta_hover_background_color="#2F3FA8"
                            cta_hover_font_color="#F7A601"
                            master_detail_mode="true"
                            program_grid_selected_row_background_color="var(--org-primary-color, #5563b8)"
                            program_grid_selected_radio_button_color="var(--org-primary-text-color, #ffffff)"
                            program_grid_odd_row_background_color="#f8fafc"
                            program_grid_even_row_background_color="#ffffff"
                            program_grid_row_font_color="#404040"
                            program_grid_container_paddings="0"
                            readonly={this.state.master_grid_readonly}
                            always_drop_down_filter_menu={true}
                            sticky_header={true}
                          ></programs-api>
                        </div>
                      </>
                    }
                  </Col>
                  {selected_program ? (
                    <Col sm={12} style={{ paddingTop: "35px", paddingRight: this.state.pageSectionsRightPadding }}>
                      {program_details}
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>

                <Row>
                    {selected_program && this.state.showForm ? this.isTeamEvent() ? (
                      <Col sm={12} style={{paddingLeft: "0"}} className="test">
                        <LeagueEnrolment 
                          email={this.props.email} 
                          password={this.props.password} 
                          club_id={this.state.organization_id} 
                          allowSelectPrograms={false}
                          overrideHandleRefresh={() => {window.location = window.location}}
                          overrideShowDetails={true}
                          overrideSelectedProgram={selected_program._id}
                          overrideToken={this.state.token}
                          onTxnUnverified={() => this.onLeagueEnrolmentTxnUnverified()}
                          />
                      </Col>
                    ) : (
                  <Col sm={12} style={{ paddingRight: this.state.pageSectionsRightPadding }}>
                      <form>
                        <div className="enrolment-shell">
                          <div className="enrolment-box">

                          <Row className="enrolment-row enrolment-row-inline">
                            {instalments.length !== 0 &&
                              instalment_field(
                                instalments,
                                instalment_number,
                                selected_program,
                                selected_plan,
                                disabled,
                                this.onInstalmentClick
                              )}
                          </Row>

                          <div className="enrolment-section enrolment-section-flat enrolment-section-spaced">
                            <div className="enrolment-section-body enrolment-section-body-tight">
                              <div className="enrolment-subcard-grid">
                                {!token ? (
                                  <div className="enrolment-subcard">
                                    <AccountInfo
                                      disabled={disabled}
                                      parentEmail={this.state.parent_email}
                                      changeState={this.changeState}
                                      invalidFieldIds={this.state.invalidFieldIds}
                                    />
                                  </div>
                                ) : null}

                                <div className="enrolment-subcard">
                                  {athlete_selector}
                                  {athlete_info}
                                </div>
                              </div>
                            </div>
                          </div>

                          {showMerchandiseSection ? (
                            <div className="enrolment-section enrolment-section-spaced">
                              <div className="enrolment-section-header">
                                <div className="enrolment-section-kicker">Team Store</div>
                              </div>
                              <div className="enrolment-section-body">
                                {this.state.organization_merch &&
                                this.state.organization_merch.length > 0 &&
                                !noMerch
                                  ? merchandise_fields
                                  : (
                                    <div className="enrolment-section-placeholder">
                                      Merchandise is not configured for this program yet.
                                    </div>
                                  )}
                              </div>
                            </div>
                          ) : null}

                          <div className="enrolment-subcard enrolment-subcard-inline enrolment-checkout-card">
                            {this.state.validationMessage ? (
                              <div className="enrolment-validation-banner" role="alert">
                                {this.state.validationMessage}
                              </div>
                            ) : null}

                            {this.state.showForm ? (
                              <div className="enrolment-checkout-row enrolment-checkout-row-payment">
                                {submission}
                                {this.state.displayPaymentForm &&
                                this.state.showPricingBreakdown
                                  ? payment_field
                                  : ""}
                                {this.state.previewFullForm ? (
                                  <div className="enrolment-success-preview">
                                    <div className="enrolment-subcard-label">Success</div>
                                    <div className="enrolment-success-preview-card">
                                      <img src="smiley.png" alt="success" className="payment-smiley" />
                                      <div className="enrolment-success-preview-title">
                                        Payment Complete! Thank You
                                      </div>
                                      <div className="enrolment-success-preview-copy">
                                        A confirmation email will be sent after the enrolment is submitted.
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                          </div>
                        </div>
                      </form>
                    </Col>
                    ) : ""}
                </Row>
              </Col>
            </div>

            {/* </form> */}
            <Modal
              dialogClassName="wide-modal"
              show={this.state.showWaiverModal}
              onHide={this.handleWaiverModal}
            >
              <Modal.Body className="black-text">
                <Row>
                  <Col
                    sm={2}
                    className="pull-right"
                    style={{ textAlign: "right" }}
                  >
                    <a onClick={() => this.setState({showWaiverModal: false})}>
                      <FontAwesomeIcon icon={faTimes} size="1x" color="black" />
                    </a>
                  </Col>
                </Row>
                <Row>
                  <h3 style={{ paddingLeft: "2%" }}>Terms</h3>
                  <div style={{ whiteSpace: "pre-wrap", padding: "2%" }}>
                    {selected_program && selected_program.waiver
                      ? selected_program.waiver.slice(3)
                      : ""}
                  </div>
                </Row>
                <div> &nbsp;</div>
              </Modal.Body>
            </Modal>
          </div>
      </StripeProvider>
    );
  }
}

export default EnrollmentForm;
